import React from "react";
import BondDataCorrectionFormBase from "./BondDataCorrectionFormBase";

function createDataCorrectionForm(kind) {
  function DataCorrectionForm(props) {
    return <BondDataCorrectionFormBase kind={kind} {...props} />;
  }
  DataCorrectionForm.displayName = `${kind}DataCorrectionForm`;
  return DataCorrectionForm;
}

export const VaDataCorrectionForm = createDataCorrectionForm("va");
export const TrusteeDataCorrectionForm = createDataCorrectionForm("trustee");
export const ProbateDataCorrectionForm = createDataCorrectionForm("probate");
export const GuardianshipDataCorrectionForm = createDataCorrectionForm("guardianship");

export const DATA_CORRECTION_FORM_BY_KIND = {
  va: VaDataCorrectionForm,
  trustee: TrusteeDataCorrectionForm,
  probate: ProbateDataCorrectionForm,
  guardianship: GuardianshipDataCorrectionForm,
};
